import VTextField from './VTextField';

VTextField.install = function install(Vue) {
  Vue.component(VTextField.name, VTextField);
};

export default VTextField;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VTextField/index.js
// module id = /yi5
// module chunks = 0